import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LinkedFinanceProjectModel, ProjectFinanceProjectModel, ProjectLinkableOutcomeModel, ProjectLinkableOutcomeRequestModel, ProjectLinkedOutcomeModel} from '../../../../../../hub_schema/hubTypes';
import { debounceTime, distinctUntilChanged, Subscription, take } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { HubRecordEditorBase } from '../../../_hub_record_editor_base';
import { UserDataService } from '../../../../../core/services/user-data.service';
import { OutcomesEditService } from '../../../outcomes-edit-container/services/outcomes-edit.service';

@Component({
  selector: 'app-link-outcomes-dialog',
  templateUrl: './link-outcomes-dialog.component.html',
  styleUrl: './link-outcomes-dialog.component.scss',
  standalone: false
})
export class LinkOutcomesDialogComponent extends HubRecordEditorBase implements OnInit, OnDestroy {
    private userDataService: UserDataService = inject(UserDataService);
    private outcomesEditService: OutcomesEditService = inject(OutcomesEditService);
    private dialogRef: MatDialogRef<LinkOutcomesDialogComponent> = inject(MatDialogRef<LinkOutcomesDialogComponent>);

    public filterFormChangedSubscription: Subscription;

    public filterForm: FormGroup = new FormGroup({
        searchTerm: new FormControl('')
    });

    public linkableOutcomes: ProjectLinkableOutcomeModel[] | undefined;
    public pagedLinkableOutcomes: ProjectLinkableOutcomeModel[] | undefined;

    private _currentPage: number = 0;
    public get currentPage(): number {
        return this._currentPage;
    }
    public set currentPage(value: number) {
        this._currentPage = value;
        this.pagedLinkableOutcomes = this.linkableOutcomes?.slice(this.currentPage * 10, (this.currentPage * 10) + 10);
    }

    public get totalPages(): number {
        if (!this.linkableOutcomes) {
            return 0;
        }
        return Math.ceil(this.linkableOutcomes?.length / 10);
    }

    public ngOnInit(): void {

        this.populateLinkableOutcomes();

        this.filterFormChangedSubscription = this.filterForm.valueChanges
        .pipe(
            debounceTime(300),
            distinctUntilChanged()
        )
        .subscribe((formValue) => {
            this.currentPage = 0;
            this.populateLinkableOutcomes();
        });
    }

    private populateLinkableOutcomes(): void {

        const request: ProjectLinkableOutcomeRequestModel = {
            projectId: this.project.projectId!,
            searchTerm: this.filterForm.value.searchTerm
        };

        this.outcomesEditService.getLinkableOutcomes(request).pipe(take(1)).subscribe((result: ProjectLinkableOutcomeModel[]) => {
            this.linkableOutcomes = result;
            this.currentPage = 0;
        });
    }

    public pageRequested(page): void {
        this.currentPage = page;
    }

    public isLinked(linkedOutcome: ProjectLinkedOutcomeModel): boolean {
        return (this.projectEditForm?.controls.linkedOutcomes.value as ProjectLinkedOutcomeModel[])
            .some(lo => lo.projectOutcomeId === linkedOutcome.projectOutcomeId);
        }

    public addLink(linkableOutcome: ProjectLinkableOutcomeModel) {
        const lo: ProjectLinkedOutcomeModel = {
            projectId: this.project.projectId!,
            project: linkableOutcome.project,
            projectOutcomeId: linkableOutcome.projectOutcomeId,
            projectOutcome: linkableOutcome.projectOutcome
        };

        this.projectEditForm?.controls.linkedOutcomes.value.push(lo);
        this.projectEditForm?.controls.linkedOutcomes.markAsDirty();
        this.projectEditForm!.controls.linkedOutcomes.updateValueAndValidity();
    }

    public close(): void {
        // return back the things that have changed.
        this.dialogRef.close();
    }

    public cancel(): void {
        this.dialogRef.close();
    }

    public ngOnDestroy(): void {
        if (this.filterFormChangedSubscription) {
            this.filterFormChangedSubscription.unsubscribe();
        }
    }

}
